import { useTranslation } from 'react-i18next';
import { LANDING_LINKS } from './landing-config';

/** Экран после окончания акции (landing, «Лендинг после окончания акции»): без входа и без блоков макета. */
export function PromoEnded() {
  const { t } = useTranslation('landing');
  return (
    <main className="ny-screen">
      <div className="card">
        <h1>{t('ended.title')}</h1>
        <p>{t('ended.text')}</p>
        <p>{t('ended.prizes')}</p>
        <a className="act" href={LANDING_LINKS.cabinet}>
          {t('ended.cabinet')}
        </a>
      </div>
    </main>
  );
}
